export const adjust = (size) => size * 0.24;

export const cs = (...classNames) => classNames.filter(Boolean).join(" ");

export const generateSecondaryText = (address) => {
  const country = address.country ? (address.country === "GB" ? "UK" : address.country) : "";
  return [address.county, country].filter(Boolean).join(", ");
};

export const generateLocationAdditionalInfo = (address) => {
  const latitude = address.lat || address.latitude;

  const getCategory = () => {
    const category = address.type || address.category;

    if (address.source === "gh_event") return "Event";
    return category;
  };

  const getSecondaryText = () => {
    if (address.secondary_text) {
      return `${address.secondary_text || ""}`;
    }

    return generateSecondaryText(address);
  };

  if (latitude && (address.category || address.type)) {
    return `${getCategory()}|${getSecondaryText(address)}`;
  }

  return "";
};

export const transformAdditionalInfo = (str) =>
  str
    ? str
        .split("|")
        .filter((content) => !!content)
        .join(" • ")
    : str;

export const getLegLocationAdditionalInfo = (address) =>
  transformAdditionalInfo(generateLocationAdditionalInfo(address));

export const renderTime = (time) => {
  let formattedTime = time.split(":");
  formattedTime = formattedTime.map((el) => (parseInt(el) > 0 ? parseInt(el) : ""));
  const h = formattedTime[0] === 1 ? "hour" : formattedTime[0] > 1 ? "hours" : "";
  const m = formattedTime[1] === 1 ? "minute" : formattedTime[1] > 1 ? "minutes" : "";
  return `${formattedTime[0]} ${h} ${formattedTime[1]} ${m}`;
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) return parts.pop().split(";").shift();
};

/**
 * @param {Object} options
 * @param {Number} [options.maxLen]
 * @param {('substring'|'word')} [options.mode]
 * @param {String} [suffix]
 */
export const shortenText =
  ({ maxLen = 10, mode = "ellipsis", suffix = "..." }) =>
  (str = "") => {
    if (str.length <= maxLen) return str;

    let trimmedString = str.substring(0, maxLen);

    if (mode === "word") {
      trimmedString = trimmedString.substring(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
    }

    return trimmedString + suffix;
  };

export const addPlusToPhone = (phone, defaultValue = "") => {
  if (phone) {
    return phone.charAt(0) === "+" ? phone : `+${phone}`;
  }

  return defaultValue;
};
